import { render } from "./NewEmail.vue?vue&type=template&id=6e7bd2d4&scoped=true&ts=true"
import script from "./NewEmail.vue?vue&type=script&lang=ts"
export * from "./NewEmail.vue?vue&type=script&lang=ts"

import "./NewEmail.vue?vue&type=style&index=0&id=6e7bd2d4&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7bd2d4"]])

export default __exports__